import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HhsgSharedModalComponent } from './modal/modal.component';
import { HhsgSharedMessageBarComponent } from './message-bar/message-bar.component';
import { HhsgSharedTabDirective } from './tab-control/tab.directive';
import { HhsgSharedDynamicTabComponent } from './tab-control/dynamic-tab.component';
import { HhsgSharedTabControlComponent } from './tab-control/tab-control.component';
import { HhsgSharedEllipsesControlComponent } from './ellipses-control/ellipses-control.component';
import { HhsgSharedAdminBaseComponent } from "./base.component";
import { MaterialDesignModule } from '../../material-design';
import { HhsgSharedDevExtremeModule } from '../devextreme.module';

@NgModule({
	imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialDesignModule,
        HhsgSharedDevExtremeModule
    ],
	declarations: [
        HhsgSharedAdminBaseComponent,
        HhsgSharedDynamicTabComponent,
        HhsgSharedEllipsesControlComponent,
        HhsgSharedMessageBarComponent,
        HhsgSharedModalComponent,
        HhsgSharedTabControlComponent,
        HhsgSharedTabDirective
    ],
	exports: [
        HhsgSharedAdminBaseComponent,
        HhsgSharedDynamicTabComponent,
        HhsgSharedEllipsesControlComponent,
        HhsgSharedMessageBarComponent,
        HhsgSharedModalComponent,
        HhsgSharedTabControlComponent
    ]
}) 
export class HhsgSharedCommonModule {
}
